// ----------------------------------------------------------------------------
// Section: Product FAQs
// ----------------------------------------------------------------------------
//
// Product FAQs Section
// - Based on the Accordion pattern
// - Uses product metafields for content
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/accordion/accordion';

// Styles
import './_faqs.scss';
